import { styled } from "goober";
import {
  type StepTestFixtureSetupRequest,
  useStepTestPin,
} from "../hooks/useStepTestPin";
import type { ParsedStep } from "../lib/parseCommitData";
import { StepRunPicker } from "./StepRunPicker";
import { StepTestPinPreview } from "./StepTestPinPreview";
import { Text } from "./Text";

const Wrap = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 0;
  border-top: 0.5px solid var(--border-alpha);
`;

const Head = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const EMPTY_PINNED: ReadonlySet<string> = new Set();

type Props = {
  step: ParsedStep;
  workflowId: string;
  branchId: string;
  commitId: string | null;
  isMainBranch: boolean;
  onAskSetupStepTest: (request: StepTestFixtureSetupRequest) => void;
};

export function PinMissingStepRow({
  step,
  workflowId,
  branchId,
  commitId,
  isMainBranch,
  onAskSetupStepTest,
}: Props) {
  const pin = useStepTestPin({
    stepDir: step.id,
    workflowId,
    branchId,
    commitId,
    isMainBranch,
    hasStorage: step.hasStorage,
    takenNames: [],
    pinnedExecutionIds: EMPTY_PINNED,
    onAskSetupStepTest,
  });

  return (
    <Wrap>
      <Head>
        <Text variant="text-small-md">{step.name}</Text>
        {pin.message ? (
          <Text variant="text-small" color="var(--text-secondary)">
            {pin.message}
          </Text>
        ) : (
          <StepRunPicker
            runs={pin.runs}
            selectedId={pin.selectedId}
            onSelect={pin.setSelectedId}
            placeholder="Pin a run as a step test"
          />
        )}
      </Head>
      {pin.selectedRun && (
        <StepTestPinPreview
          output={pin.output}
          canPin={pin.canPin}
          pinTooltip={pin.pinTooltip}
          onPin={pin.handlePin}
          onCancel={() => pin.setSelectedId(null)}
        />
      )}
    </Wrap>
  );
}
